module.exports = __webpack_public_path__ + "img/kauffman.9e112c23.jpeg";